import {
    Button,
    Dialog,
    DialogContent,
    DialogTrigger,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@repo/shadcn';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import { ChevronDownIcon, Loader2Icon, Trash } from 'lucide-react';
import { toast } from 'sonner';

import { ButtonGroup } from '@components/ui/button';

import { toastError } from '@/utils';

import {
    useDeleteStrengthMutation,
    useUpdateStrengthMutation,
} from '../../../../features/slice/products/strength/strength-api-slice';
import { StrengthForm } from '../strength-form.component';

const ActionCell = ({ row }: CellContext<any, unknown>) => {
    const [deleteStrength, { isLoading: isDeleting }] =
        useDeleteStrengthMutation();
    const [editStrength, { isLoading: isEditing }] =
        useUpdateStrengthMutation();

    const handleDeleteStrength = async (strengthId: string) => {
        const confirmed = window.confirm(
            'Are you sure you want to delete this strength?',
        );
        if (!confirmed) return;

        try {
            await deleteStrength(strengthId).unwrap();
            toast.success('Strength has been deleted');
        } catch (error) {
            toastError(
                error,
                'useStrengthList: handleDeleteStrength -> Failed to delete strength.',
            );
        }
    };

    const handleEdit = async (data: any) => {
        try {
            await editStrength({
                id: row.original.id,
                name: data.name,
                description: data.description,
            }).unwrap();
            toast.success('Strength has been updated');
        } catch (error) {
            toastError(error, 'Failed to edit strength.');
        }
    };

    return (
        <div className={'flex justify-end'}>
            <ButtonGroup>
                <Dialog>
                    <DialogTrigger>
                        <Button type={'button'} variant={'outline'}>
                            Edit
                        </Button>
                    </DialogTrigger>
                    <DialogContent>
                        <StrengthForm
                            initialValues={{
                                name: row.original.name,
                            }}
                            onSubmit={handleEdit}
                            title="Edit Strength"
                            isLoading={isEditing}
                        />
                    </DialogContent>
                </Dialog>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="!pl-2">
                            <ChevronDownIcon />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        align="end"
                        className="[--radius:1rem]"
                    >
                        <DropdownMenuGroup>
                            <DropdownMenuItem
                                className={'flex gap-2 text-destructive'}
                                onClick={() =>
                                    handleDeleteStrength(row.original.id)
                                }
                            >
                                {isDeleting ? (
                                    <Loader2Icon className={'animate-spin'} />
                                ) : (
                                    <>
                                        <Trash className={'size-4'} />
                                        Delete
                                    </>
                                )}
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>
        </div>
    );
};

export const strengthListColumns: ColumnDef<any>[] = [
    {
        accessorKey: 'name',
        header: 'Brand Name',
        cell: ({ row }) => {
            return (
                <div
                    title={row.getValue('name')}
                    // className=" w-[200px] cursor-pointer truncate"
                >
                    {row.getValue('name')}
                </div>
            );
        },
    },

    {
        accessorKey: 'actions',
        header: () => <div className="text-right">Actions</div>,
        cell: ActionCell,
    },
];
